export default __webpack_public_path__ + "static/media/torinranta_2.2fa4a410.jpg";